import { ToastProgrammatic as Toast } from 'buefy'

const getDefaultState = () => ({
  summary: null
})

export const state = () => getDefaultState()

export const getters = {
  summary(state) {
    return state.summary
  }
}

export const mutations = {
  summary(state, summary) {
    state.summary = summary
  }
}

export const actions = {
  async fetchRegistrationSummary({ commit }, registrationId) {
    // Clean up previous data
    commit('summary', null)

    await this.$coreApi
      .$get(`/staff/championship_registrations/${registrationId}`)
      .then(response => {
        commit('summary', response.data)
      })
      .catch(error => {
        Toast.open({
          message: this.$formatServerError(error, 'errors'),
          type: 'is-danger'
        })

        throw error
      })
  },

  async cancelRegistrations({ commit }, payload) {
    try {
      const response = await this.$coreApi.$post(
        '/staff/championship_registrations/cancel',
        payload
      )
      return response
    } catch (error) {
      Toast.open({
        duration: 5000,
        message: this.$i18n.t('domain.championshipRegistration.errors.notAllowedCancel', {
          serverError: this.$formatServerError(error, 'errors')
        }),
        position: 'is-top',
        type: 'is-danger'
      })

      throw error
    }
  },

  async previewCancellationEmail({ commit }, payload) {
    const response = await this.$coreApi.$post(
      '/staff/championship_registrations/preview_cancellation_email',
      payload
    )
    return response
  }
}
